// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

const TopResaleTrends: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-lg">
        Top Resale Trends
      </h1>
      <p {...DEFAULT_SAL_PROPS} className="tup-body">
        The fastest-growing brands on thredUP.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-8">
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={50}>
          <Image alt="Reformation Models" fileName="5d-sustainability.jpg" />
          <h2 className="mt-4">Sustainability Surges</h2>
          <p>
            Transparent brands claim 3x more spots in
            <br />
            top 10 (Reformation, Patagonia).
          </p>
          <ul className="mt-6">
            <li className="flex items-center mt-2 mb-2">
              <strong>Patagonia:</strong>
              <span className={styles.arrow}></span>
              <span>89%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Reformation:</strong>
              <span className={styles.arrow}></span>
              <span>94%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Everlane:</strong>
              <span className={styles.arrow}></span>
              <span>87%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>The North Face:</strong>
              <span className={styles.arrow}></span>
              <span>77%</span>
            </li>
          </ul>
        </div>
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={100}>
          <Image alt="Reformation Models" fileName="5d-quality.jpg" />
          <h2 className="mt-4">Quality Comes First</h2>
          <p>
            Luxury and designer brands move up the ranks as more people invest
            in high quality and resellable pieces.
          </p>
          <ul className="mt-4">
            <li className="flex items-center mt-2 mb-2">
              <strong>Louis Vuitton:</strong>
              <span className={styles.arrow}></span>
              <span>82%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Gucci:</strong>
              <span className={styles.arrow}></span>
              <span>26%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Marc Jacobs:</strong>
              <span className={styles.arrow}></span>
              <span>20%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Prada:</strong>
              <span className={styles.arrow}></span>
              <span>10%</span>
            </li>
          </ul>
        </div>
        <div {...DEFAULT_SAL_PROPS} data-sal-delay={150}>
          <Image alt="Reformation Models" fileName="5d-vscoGirl.jpg" />
          <h2 className="mt-4">VSCO Girls Take Over</h2>
          <p>
            The ‘90s make a comeback as Gen X brands become covetable again.
          </p>
          <ul className="mt-6">
            <li className="flex items-center mt-2 mb-2">
              <strong>Birkenstock:</strong>
              <span className={styles.arrow}></span>
              <span>84%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Vans:</strong>
              <span className={styles.arrow}></span>
              <span>78%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>PacSun:</strong>
              <span className={styles.arrow}></span>
              <span>60%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Doc Martens:</strong>
              <span className={styles.arrow}></span>
              <span>56%</span>
            </li>
            <li className="flex items-center mt-2 mb-2">
              <strong>Crocs:</strong>
              <span className={styles.arrow}></span>
              <span>48%</span>
            </li>
          </ul>
        </div>
      </div>
      <h2 {...DEFAULT_SAL_PROPS} data-sal-delay={200} className="mt-8">
        America&apos;s Thriftiest Cities
      </h2>
      <div className="flex flex-wrap items-baseline justify-center md:justify-between">
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={250}
          className="text-center mt-4 mb-4"
        >
          <Image
            alt="Buffalo Icon"
            className="m-auto"
            fileName="5d-miami.png"
            maxWidth={98}
          />
          <p>
            Fastest growing for shoppers: <strong>Miami</strong>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={300}
          className="text-center mb-4"
        >
          <Image
            alt="Buffalo Icon"
            className="m-auto"
            fileName="5d-buffalo.png"
            maxWidth={88}
          />
          <p>
            Fastest growing for sellers: <strong>Buffalo</strong>
          </p>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={350}
          className="text-center"
        >
          <Image
            alt="Statue of Liberty Icon"
            className="m-auto"
            fileName="5d-nyc.png"
            maxWidth={40}
          />
          <p>
            Most sustainable overall: <strong>New York City</strong>
          </p>
        </div>
      </div>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={400}
        className="tup-source text-center mt-8 max-w-3xl m-auto"
      >
        Resale Value Ranking: thredUP evaluated 35,000+ unique brands on its
        platform and created an aggregate score to determine a brand&apos;s
        ranking based on demand, virality, and value to the seller. Jumps &
        Drops: These reflect changes in a brand&apos;s resale ranking between
        2018 and 2019.
      </p>
    </div>
  );
};

export { TopResaleTrends };
